function ErrorFallback({ error, resetErrorBoundary }) {

  return (
    <div className="error-page">
      <div className="error-card">
        <div className="error-icon">⚠️</div>
        <h1>Oops! Something went wrong</h1>
        <p>Don’t worry, you can try again or go back to safety.</p>

        <pre className="error-message">
          {error?.message || "Unknown error"}
        </pre>

        <div className="error-actions">
          <button className="btn primary" onClick={resetErrorBoundary}>
            🔄 Try Again
          </button>
          <button
            className="btn secondary"
            onClick={() => (window.location.href = "/devices")}
          >
            🏠 Go Home
          </button>
        </div>
      </div>
    </div>
  );
}

export function InfoPage({ message }) {

  return (
    <div className="error-page">
      <div className="error-card">
        <div className="error-icon">⚠️</div>

        <pre className="error-message">
          {message || "Unknown error"}
        </pre>

        <div className="error-actions">
          <button className="btn primary" onClick={() => window.location.reload()}>
            🔄 Try Again
          </button>
          <button
            className="btn secondary"
            onClick={() => (window.location.href = "/devices")}
          >
            🏠 Go Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;